import { useTranslation } from "react-i18next";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import type { CredentialResultsDialogProps } from "./LoadingDialog.types";
import { Loader } from "@/src/components/organisms/CreateValidatedQuestionFilters/filters/Loader.component";

const LoadingDialog = ({
    open,
    onClose,
    title,
    loaderText,
}: CredentialResultsDialogProps) => {
    const { t } = useTranslation();

    return (
        <Dialog
            onClose={onClose}
            open={open}
            maxWidth={"md"}
            fullWidth
            data-testid="result"
        >
            <DialogTitle>
                <Typography variant="body2" fontWeight="bold">
                    {title}
                </Typography>
            </DialogTitle>
            <DialogContent
                style={{
                    padding: "2rem",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "1rem",
                }}
            >
                <Loader /> {loaderText}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>{t("general.oke")}</Button>
            </DialogActions>
        </Dialog>
    );
};

export default LoadingDialog;
